import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { Router, RouterOutlet, ActivatedRoute } from '@angular/router'
import { filter, mergeMap } from 'rxjs/operators'
import { GenericError } from '@auth0/auth0-angular'

import { FaConfig, FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { AuthService } from '@auth0/auth0-angular'

@Component({
    selector: 'app-root',
    imports: [FontAwesomeModule, RouterOutlet],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss',
})
export class AppComponent {
    #authService = inject(AuthService)
    #router = inject(Router)
    #route = inject(ActivatedRoute)

    ngOnInit(): void {
        this.#authService.error$
            .pipe(
                filter((e) => e instanceof GenericError && e.error === 'login_required'),
                mergeMap(() => this.#authService.loginWithRedirect())
            )
            .subscribe()
    }

    constructor(faConfig: FaConfig, library: FaIconLibrary) {
        faConfig.defaultPrefix = 'fas'
        library.addIconPacks(fas, far)
    }
}
